import React, { useState } from 'react';
import { withRouter } from 'react-router-dom';
import Fade from 'react-reveal/Fade';
import { AiOutlineHome } from 'react-icons/ai';

import Form from '../components/Form';

const Retell = props => {
  const [loading, setLoading] = useState(false);
  
  const goHome = () => {
    props.history.push('/');
  }

  return (
    <Fade>
      <div style={styles.screen}>
        <Form history={props.history} loading={loading} setLoading={setLoading}/>
        <div onClick={goHome} style={{display: 'flex', flexDirection: 'column', alignItems: 'center'}}>
          {
          !loading ? 
            <React.Fragment>
              <AiOutlineHome size={25} style={{ marginTop: 75 }}/>
              <p style={{ marginTop: 5 }}>go home</p>
            </React.Fragment> : null
          }
        </div>
      </div>
    </Fade>
  )
}

const styles = {
  screen: {
    width: '100%',
    height: window.innerHeight,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center'
  },
}

export default withRouter(Retell);